var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7606 6.34224C16.1257 6.34224 14.8003 5.0169 14.8003 3.382C14.8003 2.54055 15.1514 1.78109 15.7151 1.24213C15.2899 1.12069 14.8409 1.05566 14.3768 1.05566H5.91892C3.23302 1.05566 1.05566 3.23302 1.05566 5.91892V14.3768C1.05566 17.0627 3.23302 19.24 5.91892 19.24H14.3768C17.0627 19.24 19.24 17.0627 19.24 14.3768V5.9466C18.8048 6.19824 18.2995 6.34224 17.7606 6.34224ZM17.0419 1.85027C17.9819 2.46725 18.6952 3.40124 19.0298 4.50023C18.7199 4.85179 18.2661 5.07357 17.7606 5.07357C16.8264 5.07357 16.069 4.31623 16.069 3.382C16.069 2.70476 16.467 2.12047 17.0419 1.85027ZM5.50139 12.952C5.23774 12.7213 5.21102 12.3205 5.44172 12.0569L8.40197 8.67376C8.62874 8.41458 9.02089 8.38369 9.28545 8.60416L11.3471 10.3222L13.8996 7.40508C14.1303 7.14143 14.531 7.11471 14.7947 7.34541C15.0583 7.5761 15.085 7.97685 14.8543 8.24051L11.8941 11.6236C11.6673 11.8828 11.2752 11.9137 11.0106 11.6932L8.94897 9.97521L6.3965 12.8923C6.1658 13.156 5.76505 13.1827 5.50139 12.952Z",
    fill: "#4D410E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.69157,
    transform: "matrix(-1 0 0 1 17.7606 3.382)",
    fill: "#4D410E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoAlert);
export default __webpack_public_path__ + "static/media/crypto-alert.5144d4f9555b682af73eabc4513628e2.svg";
export { ForwardRef as ReactComponent };